module.exports = __webpack_public_path__ + "static/img/u304.416cf60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u304.png
// module id = Brbo
// module chunks = 1